import React, { useState } from 'react';
import { Grid, Stepper, Step, StepLabel } from '@material-ui/core';
import EditStep1 from '../questions/editImageMatch/EditStep1';
import EditStep2 from '../questions/editImageMatch/EditStep2';
import { State } from '../questions/AddQuestions';

const steps = ["Add question details", "Map image"];
const url = 'https://firebasestorage.googleapis.com/v0/b/test-fddd5.appspot.com/o/testing%2FArtboard65.png?alt=media&token=6157be6c-7588-42ab-ba19-a0d4e159af3e';

export interface IStepperContainerProps {
    state: State;
    data: any;
}

const EditStepperContainer: React.FC<IStepperContainerProps> = ({ state, data }) => {

    const [activeStep, setActiveStep] = useState<number>(0);
    const [form, setForm] = useState<any>();

    const stepperContent = (step: number) => {
        switch (step) {
            case 0:
                return <EditStep1 state={state} data={data} next={handleNext} />
            case 1:
                return <EditStep2 data={form} tableData={data.question.tableData} state={state} reset={handleReset} back={handleBack} />
            default:
                break;
        }
    }

    const handleBack = () => {
        if (activeStep > 0)
            setActiveStep((prevStep) => prevStep - 1);
    }

    const handleNext = (data: any) => {
        console.log("DATA", data);
        setForm(data);
        setActiveStep((prevStep) => prevStep + 1);
    }

    const handleReset = () => {
        setActiveStep(0);
    }



    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Stepper activeStep={activeStep} >
                    {
                        steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))
                    }
                </Stepper>
            </Grid>
            <Grid item container xs={12}>
                {
                    stepperContent(activeStep)
                }
            </Grid>
        </Grid>
    );
}

export default EditStepperContainer;